export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'Betrfood Restaurant';
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? '1.0.0';
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? 'https://betterfooddb-betterfood-backend.zi1kw1.easypanel.host/api/v1';

export const AUTH_TOKEN_KEY = 'bf_admin_token';
export const AUTH_USER_KEY = 'bf_admin_user';

export const ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/dashboard',
  ORDERS: '/orders',
  orderDetail: (id: number | string) => `/orders/${id}`,
  RESTAURANTS: '/restaurants',
  NEW_RESTAURANT: '/restaurants/new',
  restaurantSetup: (id: number | string) => `/restaurants/${id}/setup`,
  restaurantCreated: (id: number | string) => `/restaurants/${id}/created`,
  restaurantProfile: (id: number | string, tab?: string) =>
    tab && tab !== 'overview' ? `/restaurants/${id}?tab=${tab}` : `/restaurants/${id}`,
  restaurantReview: (id: number | string) => `/restaurants/${id}/review`,
  restaurantEnabled: (id: number | string) => `/restaurants/${id}/enabled`,
  restaurantMenuNew: (id: number | string) => `/restaurants/${id}/menu/new`,
  restaurantMenuItem: (id: number | string, itemId: number | string) => `/restaurants/${id}/menu/${itemId}`,
  DELIVERY_PARTNERS: '/delivery-partners',
  NEW_DELIVERY_PARTNER: '/delivery-partners/new',
  deliveryPartnerProfile: (id: number | string, tab?: string) =>
    tab && tab !== 'overview' ? `/delivery-partners/${id}?tab=${tab}` : `/delivery-partners/${id}`,
  deliveryPartnerReview: (id: number | string) => `/delivery-partners/${id}/review`,
  deliveryPartnerEnabled: (id: number | string) => `/delivery-partners/${id}/enabled`,
  CUSTOMERS: '/customers',
  customerProfile: (id: number | string, tab?: string) =>
    tab && tab !== 'overview' ? `/customers/${id}?tab=${tab}` : `/customers/${id}`,
  customerOrder: (userId: number | string, orderId: number | string) =>
    `/customers/${userId}/orders/${orderId}`,
  SUBSCRIPTIONS: '/subscriptions',
  SUBSCRIPTION_PLANS: '/subscriptions/plans',
  NEW_SUBSCRIPTION_PLAN: '/subscriptions/plans/new',
  editSubscriptionPlan: (id: number | string) => `/subscriptions/plans/${id}/edit`,
  WALLET_FINANCE: '/wallet-finance',
  PROMOTIONS: '/promotions',
  NEW_COUPON: '/promotions/new',
  editCoupon: (id: number | string) => `/promotions/${id}/edit`,
  REPORTS: '/reports',
  SUPPORT_TICKETS: '/support-tickets',
  supportTicket: (id: number | string) => `/support-tickets/${id}`,
  SERVICE_ZONES: '/service-zones',
  NEW_SERVICE_CITY: '/service-zones/cities/new',
  NEW_SERVICE_ZONE: '/service-zones/new',
  serviceZone: (id: number | string) => `/service-zones/${id}`,
  editServiceZone: (id: number | string) => `/service-zones/${id}/edit`,
  ADMINS: '/admins',
  NEW_ROLE: '/admins/roles/new',
  editRole: (id: number | string) => `/admins/roles/${id}/edit`,
  rolePermissions: (id: number | string) => `/admins/roles/${id}/permissions`,
  STAFF: '/admins/staff',
  INVITE_STAFF: '/admins/staff/invite',
  staffProfile: (id: number | string) => `/admins/staff/${id}`,
  editStaff: (id: number | string) => `/admins/staff/${id}/edit`,
  BANNERS_CATEGORIES: '/banners-categories',
  NEW_FOOD_CATEGORY: '/banners-categories/categories/new',
  editFoodCategory: (id: number | string) => `/banners-categories/categories/${id}/edit`,
  MOBILE_BANNERS: '/banners-categories/banners',
  NEW_MOBILE_BANNER: '/banners-categories/banners/new',
  viewMobileBanner: (id: number | string) => `/banners-categories/banners/${id}`,
  editMobileBanner: (id: number | string) => `/banners-categories/banners/${id}/edit`,
  NOTIFICATIONS: '/notifications',
  NEW_NOTIFICATION: '/notifications/new',
  SETTINGS: '/settings',
  INVOICE_GST: '/invoice-gst',
  invoiceDetail: (id: number | string) => `/invoice-gst/${id}`,
  OPS_ADMIN: '/ops-admin',
} as const;

export const ORDER_STATUS_COLORS: Record<string, string> = {
  pending: 'gold',
  confirmed: 'blue',
  preparing: 'default',
  on_time: 'green',
  in_transit: 'blue',
  delayed: 'orange',
  kitchen_issue: 'red',
  delivered: 'green',
  cancelled: 'red',
  refunded: 'green',
};

export const ORDER_STATUS_LABELS: Record<string, string> = {
  pending: 'Pending',
  confirmed: 'Confirmed',
  preparing: 'Preparing',
  on_time: 'On time',
  in_transit: 'In Transit',
  delayed: 'Delayed',
  kitchen_issue: 'Kitchen issue',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
  refunded: 'Refunded',
};

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  upi: 'UPI',
  card: 'Card',
  wallet: 'Wallet',
  cod: 'Cash',
};

export const RESTAURANT_STATUS_COLORS: Record<string, string> = {
  active: 'green',
  inactive: 'red',
  pending: 'orange',
};
